import Icon, { BaseIconProps } from './react-components/Icon'

/**
 * Renders the generated SVG icon PersonalInformationIcon as a React component.
 * These icons are rendered with special wrapper helpers via our internal <Icon> component,
 * which is built on top of MUI's <SvgIcon> component.
 * If you're experiencing rendering issues, contact the UIPT team or consult the docs
 * for the underlying components. Do not modify this icon directly. It is a generated file.
 */ const PersonalInformationIcon = (props: BaseIconProps) => {
  return (
    <Icon {...props} nativeViewbox="0 0 24 24">
      <path
        d="M11.6426 14.0703C19.1611 14.0703 22 18.8599 22 23.8818C13.5385 23.8818 8.15385 23.8818 2 23.8818C2 18.86 4.30768 14.0703 11.6426 14.0703ZM11.6426 15.0703C8.20951 15.0703 6.11065 16.1798 4.84473 17.7266C3.7332 19.0847 3.17228 20.893 3.03516 22.8818H20.957C20.7919 20.9282 20.1317 19.1283 18.8984 17.7637C17.4747 16.1884 15.1779 15.0703 11.6426 15.0703ZM12.5684 0.125977C15.8691 0.289546 18.4941 2.95838 18.4941 6.22656L18.4854 6.54102C18.3178 9.7683 15.5891 12.3349 12.2471 12.335L11.9258 12.3271C8.62511 12.1637 6.00026 9.49464 6 6.22656C6.00006 2.85298 8.797 0.117188 12.2471 0.117188L12.5684 0.125977ZM12.2471 1.11816C9.32804 1.11816 7.00006 3.42627 7 6.22656C7.00027 9.02669 9.32817 11.335 12.2471 11.335C15.1659 11.3349 17.4939 9.02666 17.4941 6.22656C17.4941 3.4263 15.1661 1.11821 12.2471 1.11816Z"
        fill="#503291"
      />
    </Icon>
  )
}
export default PersonalInformationIcon
